import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Header from '~/Components/Header/Header';
import Loading from '~/Components/Loading';
import FormAtivacao from './FormAtivacao';
import GridHistorico from './GridHistorico';
import {
  listarValidadorUsuariosElegiveis,
  listarValidadorHistorico,
  ativarValidadorAssinaturaDigital,
} from '~/Services/Service';

const ValidadorAssinaturaDigital = () => {
  const [tipo, setTipo] = useState('');
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);
  const [usuariosElegiveis, setUsuariosElegiveis] = useState([]);
  const [historico, setHistorico] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingUsuarios, setLoadingUsuarios] = useState(false);
  const [ordenacao, setOrdenacao] = useState({ campo: 'data_hora_inclusao', direcao: 'desc' });

  useEffect(() => {
    let ativo = true;

    setLoadingUsuarios(true);
    listarValidadorUsuariosElegiveis()
      .then((res) => {
        if (!ativo) return;
        setUsuariosElegiveis(res || []);
      })
      .catch((err) => {
        if (!ativo) return;
        const mensagem = err && err.message
          ? err.message
          : 'Erro ao carregar lista de usuários.';
        toast.error(mensagem);
      })
      .finally(() => {
        if (!ativo) return;
        setLoadingUsuarios(false);
      });

    return () => {
      ativo = false;
    };
  }, []);

  useEffect(() => {
    let ativo = true;

    if (!tipo) {
      setHistorico([]);
      return () => {
        ativo = false;
      };
    }

    listarValidadorHistorico(tipo)
      .then((res) => {
        if (!ativo) return;
        setHistorico(res || []);
      })
      .catch((err) => {
        if (!ativo) return;
        const mensagem = err && err.message
          ? err.message
          : 'Erro ao carregar histórico.';
        toast.error(mensagem);
      });

    return () => {
      ativo = false;
    };
  }, [tipo]);

  const handleAtivar = async () => {
    setLoading(true);
    try {
      await ativarValidadorAssinaturaDigital(usuarioSelecionado.codigo_usuario, tipo);
      const atualizado = await listarValidadorHistorico(tipo);
      setHistorico(atualizado || []);
      setUsuarioSelecionado(null);
      toast.success('Validador ativado com sucesso.');
    } catch (err) {
      const mensagem = err && err.message ? err.message : 'Erro ao ativar validador.';
      toast.error(mensagem);
    } finally {
      setLoading(false);
    }
  };

  const handleOrdenacao = (campo) => {
    setOrdenacao((prev) => {
      if (prev.campo === campo) {
        return { campo, direcao: prev.direcao === 'asc' ? 'desc' : 'asc' };
      }
      return { campo, direcao: 'asc' };
    });
  };

  const historicoOrdenado = historico.slice().sort((a, b) => {
    const dir = ordenacao.direcao === 'asc' ? 1 : -1;
    let valA = a[ordenacao.campo];
    let valB = b[ordenacao.campo];
    if (valA == null) valA = '';
    if (valB == null) valB = '';
    if (typeof valA === 'string') {
      return dir * valA.toLowerCase().localeCompare(String(valB).toLowerCase());
    }
    return dir * (valA - valB);
  });

  if (loadingUsuarios) return <Loading />;

  return (
    <Container fluid className="px-3 py-3">
      <Header title="Validador Assinatura Digital" />
      <FormAtivacao
        tipo={tipo}
        onTipoChange={setTipo}
        usuariosElegiveis={usuariosElegiveis}
        usuarioSelecionado={usuarioSelecionado}
        onUsuarioChange={setUsuarioSelecionado}
        onAtivar={handleAtivar}
        loading={loading}
      />
      <GridHistorico
        rows={historicoOrdenado}
        ordenacao={ordenacao}
        onOrdenacao={handleOrdenacao}
      />
    </Container>
  );
};

export default ValidadorAssinaturaDigital;
